import { Component, ElementRef, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { AppComponent } from 'src/app/app.component';
import { AuthService } from 'src/app/_services/auth.service';
import { NavService } from 'src/app/_services/nav.service';
import { ToastrService } from 'src/app/_services/toastr.service';
import { CompanyDocumentService } from 'src/app/_services/company-document.service';

@Component({
  selector: 'app-company-documents',
  templateUrl: './company-documents.component.html',
  styleUrls: ['./company-documents.component.css'],
})
export class CompanyDocumentsComponent {
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  documents: any[] = [];
  selectedFile: File;
  documentType = 'RAT';
  notes = '';
  isModalOpen = false;
  isLoading = false;
  isUploading = false;

  constructor(
    private authService: AuthService,
    private appComponent: AppComponent,
    private navService: NavService,
    private documentService: CompanyDocumentService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.appComponent.setTitle(this.translate.instant('menu.administration.companyDocuments'));
    this.authService.pageVisit().subscribe();
    this.navService.emitNavChangeEvent({
      parent: 'safecloud',
      child: 'menu.administration.companyDocuments',
      description: 'pageDescriptions.companyDocuments',
    });
    this.loadDocuments();
  }

  loadDocuments() {
    this.isLoading = true;
    this.documentService.getAll().subscribe({
      next: documents => { this.documents = documents; this.isLoading = false; },
      error: () => { this.isLoading = false; this.toastr.error(this.translate.instant('companyDocumentsPage.loadError')); }
    });
  }

  openUpload() { this.resetUpload(); this.isModalOpen = true; }
  closeUpload() { if (!this.isUploading) this.isModalOpen = false; }
  selectFile(event: Event) { this.setFile((event.target as HTMLInputElement).files?.[0]); }
  onDrop(event: DragEvent) { event.preventDefault(); this.setFile(event.dataTransfer?.files?.[0]); }
  allowDrop(event: DragEvent) { event.preventDefault(); }

  upload() {
    if (!this.selectedFile || this.isUploading) return;
    this.isUploading = true;
    this.documentService.upload(this.selectedFile, this.documentType, this.notes).subscribe({
      next: () => { this.toastr.success(this.translate.instant('companyDocumentsPage.uploadSuccess')); this.isUploading = false; this.isModalOpen = false; this.loadDocuments(); },
      error: error => { this.isUploading = false; this.toastr.error(error?.error || this.translate.instant('companyDocumentsPage.uploadError')); }
    });
  }

  toggle(document: any) {
    this.documentService.toggle(document.id).subscribe({
      next: (result: any) => document.isActive = result.isActive,
      error: () => this.toastr.error(this.translate.instant('companyDocumentsPage.toggleError'))
    });
  }

  delete(document: any) {
    Swal.fire({
      title: this.translate.instant('companyDocumentsPage.deleteConfirmTitle'),
      text: document.fileName,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('companyDocumentsPage.delete'),
      cancelButtonText: this.translate.instant('companyDocumentsPage.cancel')
    }).then(result => {
        if (!result.isConfirmed) return;
        this.documentService.delete(document.id).subscribe({
          next: () => { this.toastr.success(this.translate.instant('companyDocumentsPage.deleteSuccess')); this.loadDocuments(); },
          error: () => this.toastr.error(this.translate.instant('companyDocumentsPage.deleteError'))
        });
      });
  }

  formatSize(bytes: number) { return bytes < 1024 * 1024 ? (bytes / 1024).toFixed(1) + ' KB' : (bytes / 1024 / 1024).toFixed(1) + ' MB'; }

  private setFile(file?: File) {
    if (!file) return;
    const valid = ['application/pdf', 'text/plain', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    if (file.size > 10 * 1024 * 1024 || !valid.includes(file.type)) { this.toastr.error(this.translate.instant('companyDocumentsPage.invalidFile')); return; }
    this.selectedFile = file;
  }
  private resetUpload() { this.selectedFile = undefined; this.documentType = 'RAT'; this.notes = ''; if (this.fileInput) this.fileInput.nativeElement.value = ''; }
}
